module.exports = __webpack_public_path__ + "img/icons/image-d5d2887585c314245e57b8090cd70c37.svg";